import { FeatureDefinition } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'config/growthbook/featureFlags';

/**
 * Applied when the GrowthBook CDN fetch fails or no API key is configured.
 * Telemetry flags default ON so a CDN outage cannot silently disable frontend
 * observability.
 */
export const fallbackFeatures: Record<string, FeatureDefinition> = {
  [FeatureFlags.DATADOG_RUM]: { defaultValue: true },
  [FeatureFlags.DATADOG_LOGS_FE]: { defaultValue: true },
};
